import { useContext, useEffect, useMemo, useState } from 'react';
import { BranchTypes } from '../../constnats/schemaConstants';
import { TableUpdateContext } from '../../contexts/reviewTypeContext';
import { SchemasContext } from '../../contexts/schemaContext';
import Assert from '../../utils/asserts';
import TableUpdatesRepo from '../../utils/repository/tableUpdatesRepo';
import BranchSettingsProvider from '../branchSettingsProvider';
import { UpdatePhase } from '../financialTables/configuration/constants';
import { RESPONSE_STATUS } from '../../constnats/general';
import Alert from '../../utils/alert';

const TableUpdateContextProvider = ({ currentSchema, children }) => {
    const schemaContext = useContext(SchemasContext);
    const srcSchema = useMemo(() => {
        return schemaContext.find((s) => s.name === currentSchema.name && s.branchType === BranchTypes.MAIN);
    }, [currentSchema, schemaContext]);

    const [reviews, setReviews] = useState([])
    const [updatePhase, setUpdatePhase] = useState(null)
    const [updateId, setUpdateId] = useState(null)
    const [reconciliationEvents, setReconciliationEvents] = useState([])

    useEffect(() => {
        if(currentSchema.branchType === BranchTypes.MAIN) {
            return;
        }

        /**
         * Handles cases where the source schema (srcSchema) cannot be found.
         * This can occur if a branch is renamed with a typo or a different spelling,
         * causing the branch names to no longer match exactly. Since the lookup relies
         * on exact name and branchType matches, srcSchema may be undefined.
         * To prevent errors, we log the issue and exit early if srcSchema is missing.
         * 
         * Example:
         * - Original branch: "Reconcilliation" (with typo)
         * - Edited branch: "Reconciliation" (correct spelling)
         * Because the names differ, srcSchema will not be found.
         */
        Assert.trueVal(!!srcSchema, `Could not find Source Schema. Schema Id${currentSchema.id}`)
        if(!srcSchema) {
            return
        }
    
        TableUpdatesRepo.findActive({ srcSchema: srcSchema.id }, (response) => {
            if (response.status === RESPONSE_STATUS.SUCCESS) {
                const update = response.data;
                if (update) {
                    setUpdatePhase(update.phase);
                    setUpdateId(update.id);
                    setReconciliationEvents(update.reconciliationEvents);
                    TableUpdatesRepo.listReviews([update.id], (reviews) => {
                        setReviews(reviews);
                    });
                }
            } else {
                Alert.error(response.message);
            }
        });
    }, [srcSchema, currentSchema]);

    return (
        <TableUpdateContext.Provider
            value={{ updatePhase, reviews, updateId, reconciliationEvents, schemaName: currentSchema.name, branchType: currentSchema.branchType }}
        >
            <BranchSettingsProvider currentSchemaId={currentSchema.id}>{children}</BranchSettingsProvider>
        </TableUpdateContext.Provider>
    );
};

export default TableUpdateContextProvider;


